import React from "react";
import { Modal } from "react-bootstrap";
import { Button, Box, Icon, Heading, Text } from "./elements";

/**
 * Shared confirmation step for every delete action in the dashboard.
 *
 * `item` doubles as the open/closed flag: pass the record being deleted, or a
 * falsy value to close. `name` is shown so the user can see what they picked.
 */
export default function ConfirmDeleteModal({
  item,
  name,
  label = "record",
  busy,
  onCancel,
  onConfirm,
}) {
  return (
    <Modal show={Boolean(item)} onHide={busy ? undefined : onCancel}>
      <Box className="mc-alert-modal">
        <Icon type="delete" />
        <Heading as="h3">Are you sure?</Heading>
        <Text as="p">
          {name
            ? `"${name}" will be permanently deleted. This cannot be undone.`
            : `This ${label} will be permanently deleted. This cannot be undone.`}
        </Text>
        <Modal.Footer>
          <Button
            type="button"
            className="btn btn-secondary"
            disabled={busy}
            onClick={onCancel}
          >
            No, cancel
          </Button>
          <Button
            type="button"
            className="btn btn-danger"
            disabled={busy}
            onClick={onConfirm}
          >
            {busy ? "Deleting..." : "Yes, delete"}
          </Button>
        </Modal.Footer>
      </Box>
    </Modal>
  );
}
